var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    stroke: "currentColor",
    baseProfile: "tiny-ps",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    width: 25,
    height: 25,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.96 10.26c-2.27 0-4.1-1.83-4.1-4.1a4.1 4.1 0 118.2 0c0 2.27-1.83 4.1-4.1 4.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.67 19.53c-.19-.01-.39-.02-.59-.04-.19-.01-.39-.03-.58-.05-.2-.02-.39-.05-.59-.08-.19-.02-.38-.06-.58-.09-.32-.06-.64-.11-.96-.15-.32-.05-.64-.09-.97-.12-.32-.03-.64-.06-.97-.07-.32-.02-.65-.04-.97-.04-.33 0-.65.02-.97.04-.33.01-.65.04-.98.07-.32.03-.64.07-.96.12-.33.04-.65.09-.97.15-.19.03-.38.07-.58.09a10.813 10.813 0 01-1.17.13c-.19.02-.39.03-.58.04-1.14 0-1.84-.33-1.84-1.99 0-3.69 3.61-6.7 8.05-6.7.75-.03 1.49.05 2.22.23.72.18 1.42.45 2.07.81.65.37 1.25.82 1.79 1.34.53.52.99 1.12 1.36 1.76.1.2.19.4.27.61.07.21.14.42.19.64.05.21.09.43.11.65.03.22.04.44.04.66 0 1.66-.7 1.99-1.84 1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.01 18.72a.396.396 0 01.02-.56c.16-.15.41-.15.56.02l2.73 2.92c.15.16.14.41-.02.56-.16.15-.42.15-.57-.02l-2.72-2.92z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.52 19.32A3.09 3.09 0 0113.81 17c-.39-1.67.65-3.33 2.32-3.72 1.67-.38 3.33.66 3.71 2.32.39 1.67-.65 3.33-2.32 3.72z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchCustomer);
export default __webpack_public_path__ + "static/media/search-customer.a302810aad5de204ff172b7e65c63d0c.svg";
export { ForwardRef as ReactComponent };